import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class DeviceLoginService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Create new device authentication flow
     * @returns DeviceLogin OK.
     * @throws ApiError
     */
    authorizeDeviceLogin({ requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/device-authorize', body: requestBody, mediaType: 'application/json', errors: {
                401: `OAuth2 RFC compliant error response.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get access token if it's available
     * @returns TokenResponse OK.
     * @throws ApiError
     */
    getDeviceLoginToken({ requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/device-token', body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get new access token with refresh token
     * @returns TokenResponse OK.
     * @throws ApiError
     */
    rotateToken({ requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/device-rotate-token', body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=DeviceLoginService.js.map